import { fetchCruiseSearchFacets } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EMPTY_CRUISE_FACETS_V2 } from 'reducers/cruises'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect, useMemo } from 'react'

const emptyState: App.CruiseSearchFacetState = {
  fetching: true,
  facets: EMPTY_CRUISE_FACETS_V2,
}

export const FACET_TYPES: Record<string, App.CruiseSearchFacetType> = {
  CRUISE_LINES: 'cruise_lines',
}

function useCruiseSearchFacets(
  params: App.CruiseSearchFacetParams,
  options?: App.CruiseSearchFacetOptions,
): [App.CruiseSearchFacetsV2, boolean, any] {
  const isDisabled = options?.isDisabled === true
  const dispatch = useAppDispatch()
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const key = useMemo(() => getObjectKey({ ...params, region }), [params, region])

  const facetState = useAppSelector(state => state.cruise.cruiseFacets[key] ?? emptyState)
  useEffect(() => {
    if (isDisabled) return
    dispatch(fetchCruiseSearchFacets(params, region))
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [key, isDisabled, region])

  if (isDisabled) {
    return [EMPTY_CRUISE_FACETS_V2, false, undefined]
  }

  return [facetState.facets, facetState.fetching || false, facetState.error]
}

export default useCruiseSearchFacets
